import { render, staticRenderFns } from "./Initiate-asale.vue?vue&type=template&id=16f756cf&scoped=true&"
import script from "./Initiate-asale.vue?vue&type=script&lang=js&"
export * from "./Initiate-asale.vue?vue&type=script&lang=js&"
import style0 from "./Initiate-asale.vue?vue&type=style&index=0&id=16f756cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f756cf",
  null
  
)

export default component.exports